import React from 'react';
import { LinksData } from '../../../prompt/preview/components/stats/models/StatsModel';
import { getMonitorTypesForChatType } from '../../../../shared/helpers/MonitorTypeHelpers';
import { ChatType, getChatTypeToName } from '../../../../shared/types/monitor/ChatType';
import { useTranslation } from 'react-i18next';
import { formatLargeNumber } from '../../../../shared/utils/utils';
import { getChatTypeIcon } from '../../../../shared/helpers/ChatTypeHelpers';

interface CitationsBoxProps {
  chatType: ChatType;
  linksData: LinksData[];
}

const CitationsBox: React.FC<CitationsBoxProps> = ({ chatType, linksData }) => {
  const { t } = useTranslation();
  const sourcesCount = linksData
    .filter((linkData) =>
      linkData.models.some((model) => getMonitorTypesForChatType(chatType).includes(model))
    )
    .map((linkData) => linkData.count / linkData.models.length);
  const total = sourcesCount.reduce((sum, value) => sum + value, 0);

  return (
    <div className="citations-box">
      <div className="citations-box__header">
        <span className={`${getChatTypeIcon(chatType)} ico--md`} />
        <div className="citations-box__title">{getChatTypeToName(chatType)}</div>
      </div>
      <div className="citations-box__row">
        <div className="citations-box__value-box">
          <span className="citations-box__value">{formatLargeNumber(Math.round(total))}</span>
        </div>
      </div>
      <div className="citations-box__row">
        {t('pages')}: {formatLargeNumber(sourcesCount.length)}
      </div>
    </div>
  );
};

export default CitationsBox;
